var map = {
	"./": 1172,
	"./about-page/cooperation.png": 9798,
	"./about-page/delivery.png": 27,
	"./about/about-1.png": 7139,
	"./about/about-2.png": 1560,
	"./about/about-3.png": 9352,
	"./basket-button.svg": 3862,
	"./basket-img.png": 4989,
	"./burger-close.svg": 3085,
	"./burger.svg": 5131,
	"./delete-button.svg": 5980,
	"./delete-product.png": 3422,
	"./delivery-page/payment.png": 5115,
	"./error.svg": 8498,
	"./footer/pay.png": 863,
	"./fruits-small-1.png": 4822,
	"./fruits-small-2.png": 2910,
	"./fruits.png": 1702,
	"./fruits/apple.jpg": 9070,
	"./fruits/banana.jpg": 476,
	"./fruits/blueGrape.jpg": 9955,
	"./fruits/broom.jpg": 2641,
	"./fruits/grape.jpg": 8587,
	"./fruits/lemon.jpg": 5747,
	"./fruits/orange.jpg": 3666,
	"./fruits/pear.jpg": 2178,
	"./green/artichoke.jpg": 9720,
	"./green/brusselsSprouts.jpg": 100,
	"./green/cherry.jpg": 4613,
	"./green/chicory.jpg": 9986,
	"./green/chiliPepper.jpg": 7448,
	"./green/greenPepper.jpg": 1777,
	"./green/pinkPotatoes.jpg": 2800,
	"./green/yellowPepper.jpg": 1246,
	"./index": 1172,
	"./index.js": 1172,
	"./info/info-1.png": 5872,
	"./info/info-2.png": 625,
	"./info/info-3.png": 6305,
	"./input-search.svg": 8476,
	"./minus-button.svg": 3264,
	"./open-basket.svg": 3971,
	"./plus-button.svg": 4340,
	"./scroll-up.svg": 1498,
	"./vegetables/beet.jpg": 1893,
	"./vegetables/carrot.jpg": 2029,
	"./vegetables/leek.jpg": 6314,
	"./vegetables/onion.jpg": 8374,
	"./vegetables/potato.jpg": 5582,
	"./vegetables/radish.jpg": 7072,
	"./vegetables/squash.jpg": 6173,
	"./vegetables/tomato.jpg": 6858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;